import common from '../common';
import Scene from './Scene';

export default class SplashScene extends Scene {
	constructor() {
		super();

		this.destroyed		= false;
		this._playButton 	= null;
		this._muteButton 	= null;
		this._homeButton 	= null;
	}

	init() {
		super.init();
		const bg = new PIXI.Sprite(P3.assets.texture('ui_bg_1'));

		bg.anchor.set(0.5);
		bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		bg.width = 2000;
		this.addChild(bg);

		for (let i = 0; i < 4; i++) {
			const codetile = new PIXI.Sprite(P3.assets.texture('ui_bg_1_tile'));

			codetile.anchor.set(0, 0.5);
			codetile.position.set(-68 + (i * 450), common.STAGE_HEIGHT * 0.5);
			this.addChild(codetile);
		}

		this._createVerticalLines(12);
		this._createHorizontalLines(4);

		const frameTop = new PIXI.Container();
		frameTop.rotation = 180 * PIXI.DEG_TO_RAD;
		frameTop.position.set(common.STAGE_WIDTH * 0.5, 0);
		this.addChild(frameTop);

		const frameTop1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop1.anchor.set(0, 0);
		frameTop1.scale.x = -1;
		frameTop.addChild(frameTop1);

		const frameTop2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop2.anchor.set(0, 0);
		frameTop.addChild(frameTop2);

		const frameBottom = new PIXI.Container();
		this.addChild(frameBottom);

		const frameBottom1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom1.anchor.set(1, 1);
		frameBottom.addChild(frameBottom1);

		const frameBottom2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom2.anchor.set(1, 1);
		frameBottom2.scale.x = -1;
		frameBottom.addChild(frameBottom2);

		frameBottom.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT + frameBottom1.height);

		new P3.utils.TWEEN.Tween(frameTop.position, this.tweens)
			.to({
				y: frameTop.y + frameTop.height
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(500)
			.start();

		new P3.utils.TWEEN.Tween(frameBottom.position, this.tweens)
			.to({
				y: frameBottom.y - frameBottom.height
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(500)
			.start();

		this._animateIntro();

		let states = new P3.ButtonStates();

		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_home');

		this._homeButton = new P3.Button(states);
		this._homeButton.clickSoundName = 'sfx_btn_press_00';
		this._homeButton.overSoundName = 'sfx_btn_rollover_00';
		this._homeButton.signals.click.add(() => {
			return this.signals.previous.dispatch('home');
		}, this);
		this._homeButton.position.set(common.STAGE_WIDTH * 0.5 - 125, common.STAGE_HEIGHT * 0.5 + 50);
		this.addChild(this._homeButton);

		states = new P3.ButtonStates();
		states.normal 	= P3.assets.texture('ui_btn_xxl_out');
		states.over 	= P3.assets.texture('ui_btn_xxl_over');
		states.down 	= P3.assets.texture('ui_btn_xxl_down');
		states.icon 	= P3.assets.texture('ui_icon_play');

		this._playButton = new P3.Button(states);
		this._playButton.signals.click.add(this.onPlayClick, this);
		this._playButton.clickSoundName = 'sfx_btn_press_00';
		this._playButton.overSoundName = 'sfx_btn_rollover_00';
		this._playButton.position.set(common.STAGE_WIDTH * 0.5 + 390, common.STAGE_HEIGHT * 0.5 + 225);
		this.addChild(this._playButton);

		this.outTween = new P3.utils.TWEEN.Tween(this._playButton, this.tweens)
			.to({
				rotation: this._playButton.rotation - (5 * PIXI.DEG_TO_RAD)
			}, 200)
			.easing(P3.utils.Easing.Back2.Out);

		this.inTween = new P3.utils.TWEEN.Tween(this._playButton, this.tweens)
			.to({
				rotation: this._playButton.rotation + (5 * PIXI.DEG_TO_RAD)
			}, 200)
			.easing(P3.utils.Easing.Back2.Out)
			.onComplete(() => {
				P3.utils.delay(1, () => {
					!this.destroyed && this.outTween.start();
				});
			});

		this.outTween.onComplete(() => {
			return this.inTween.start();
		});

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_sound_on');
		states.iconAlt = P3.assets.texture('ui_icon_sound_off');

		this._muteButton = new P3.MuteButton(states);
		this._muteButton.signals.click.add(common.toggleAudio);
		this._muteButton.clickSoundName = 'sfx_btn_press_00';
		this._muteButton.overSoundName = 'sfx_btn_rollover_00';
		this._muteButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 75, 75);
		this.addChild(this._muteButton);
	}

	_animateIntro() {
		const mx = common.STAGE_WIDTH / 2;
		const my = common.STAGE_HEIGHT / 2;

		const panel1 = new PIXI.Sprite(P3.assets.texture('intro_panel1'));

		panel1.anchor.set(0.5);
		panel1.x = mx - 300;
		panel1.y = -my;

		const panel2 = new PIXI.Sprite(P3.assets.texture('intro_panel2'));

		panel2.anchor.set(0.5);
		panel2.x = mx - 270;
		panel2.y = my * 3;

		const panel3 = new PIXI.Sprite(P3.assets.texture('intro_panel3'));

		panel3.anchor.set(0.5);
		panel3.x = mx + 50;
		panel3.y = -my;

		const panel4 = new PIXI.Sprite(P3.assets.texture('intro_panel4'));

		panel4.anchor.set(0.5);
		panel4.x = mx + 350;
		panel4.y = my * 3;

		this.addChild(panel4, panel2, panel3, panel1);

		panel1.scale.set(0.9);
		panel2.scale.set(0.9);
		panel3.scale.set(0.9);
		panel4.scale.set(0.9);

		const panels = [panel1, panel2, panel3, panel4];
		const panelTargets = [
			{x: mx - 350, y: my + 100},
			{x: mx - 100, y: my - 150},
			{x: mx + 50, y: my + 150},
			{x: mx + 275, y: my - 100}
		];

		for (const i in panels) {
			const tween = new P3.utils.TWEEN.Tween(panels[i], this.tweens)
				.to({
					x : panelTargets[i].x,
					y : panelTargets[i].y
				}, 300)
				.delay(1000 * i)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.onStart(() => {
					P3.audio.playSound('sfx_intro_panel_whoosh_00');
				})
				.start();

			if (Number(i) === panels.length - 1) {
				tween.onComplete(() => {
					this.outTween.start();
				});
			}
		}
	}

	_createHorizontalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 0.7);
			line.rotation = (P3.math.random(-5, 5) * PIXI.DEG_TO_RAD) + (90 * PIXI.DEG_TO_RAD);
			line.height = common.STAGE_WIDTH;
			line.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT / count) * i);
			this.addChild(line);

			// up-down anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					y: line.position.y + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	_createVerticalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));
			const angle = P3.math.random(-10, 10);

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 1);
			line.rotation = angle * PIXI.DEG_TO_RAD;
			line.height = common.STAGE_HEIGHT;
			line.position.set((common.STAGE_WIDTH / count) * i, common.STAGE_HEIGHT * 0.5);
			this.addChild(line);

			// left-right anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					x: line.position.x + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	appear() {
		super.appear();
	}

	onPlayClick() {
		/* if (PIXI.utils.isMobile.android.device && screenfull.enabled)
			screenfull.request();*/

		P3.audio.stopMusic();
		P3.audio.playSound('music_splash_playsting_00');
		this.signals.next.dispatch(this);
	}

	destroy() {
		// clean up goes here
		this.destroyed = true;
		this.outTween.stop();
		this.inTween.stop();
		super.destroy();
	}

	resize() {
		super.resize();
		this._muteButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 75, 75);
		this._homeButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 75, 75);
		this._playButton.position.set(common.STAGE_WIDTH * 0.5 + 390, common.STAGE_HEIGHT * 0.5 + 225);
	}

	update() {
		super.update();
	}
}
